import intl from "react-intl-universal";
import { Routes } from '../layouts/Routes';
import ErrorMessage from './ErrorMessage';
import React from 'react';
import { EXTENSION_NOT_FOUND, MEETING_NAME_EXISTS } from '../utils/constants/errors';

interface Props {
  scheduleMeetingError: string;
  scheduleMeetingErrorDetails?: object;
}

export const MeetingError = ({ scheduleMeetingError, scheduleMeetingErrorDetails }: Props) => {
  let errorText = intl.get('meetingScheduleError');

  if (scheduleMeetingError === MEETING_NAME_EXISTS) {
    errorText = intl.get('meetingNameAlreadyExists', scheduleMeetingErrorDetails);
  }

  if (scheduleMeetingError === EXTENSION_NOT_FOUND) {
    errorText = intl.get('meetingNotFound', scheduleMeetingErrorDetails);
  }

  return (
    <ErrorMessage
      top={intl.get('weAreSorry')}
      middle={errorText}
      bottom={intl.getHTML('pleaseGoToSettings', { settingsRoute: Routes.SETTINGS })}
    />
  );
};
